import axiosClient from "../apiClient";

export const PlanListService = async () => {
  try {
    const response = await axiosClient.get("/plan");
    return response;
  } catch (error) {
    return error;
  }
};
